import { useTranslations } from '@vocab/react';
import { Alert, Text, TextLinkButton } from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';

type Props = {
  onClickPurchase: () => void;
};

export const PurchaseReferenceCheckAddonAlert: FC<Props> = ({
  onClickPurchase,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Alert tone="promote">
      <Text>
        {t(
          'Buy the <TextLinkButton>reference check add-on</TextLinkButton> to see the full report and order more reference checks.',
          {
            TextLinkButton: (children) => (
              <TextLinkButton onClick={onClickPurchase}>
                {children}
              </TextLinkButton>
            ),
          },
        )}
      </Text>
    </Alert>
  );
};
